import { FormProvider, useForm } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";
import { toast } from "react-toastify";
import { Col, Row } from "react-bootstrap";

import { deleteQuoteReuest } from "api";
import errorToast from "helpers/errorToast";
import Button from "components/atoms/Button/Button";
import Dialog from "components/organisms/Dialog/Dialog";
import testIds from "constants/testIds";

interface ICancelDialogProps {
  isOpen: boolean;
  close: () => void;
  referenceId: string;
  refetchQuotationLists: Function;
}

function CancelDialog(props: ICancelDialogProps) {
  const { isOpen, close, referenceId, refetchQuotationLists } = props;

  const intl = useIntl();
  const methods = useForm();
  const { handleSubmit } = methods;

  const handleCancelRequest = () => {
    deleteQuoteReuest(referenceId)
      .then(() => {
        refetchQuotationLists();
        toast(
          intl.formatMessage({
            id: "quote.cancelSuccessMsg",
            defaultMessage: "Quotation cancelled successfully",
          }),
          { type: "success" },
        );
        close();
      })
      .catch((error) => errorToast(error));
  };

  return (
    <Dialog
      size="sm"
      title={intl.formatMessage({
        id: "quote.cancelQuote",
        defaultMessage: "Cancel quote",
      })}
      show={isOpen}
      onHide={close}
    >
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(handleCancelRequest)}>
          <div style={{ maxWidth: 600 }}>
            <p className="text-secondary">
              <FormattedMessage
                id="quote.isCancel"
                defaultMessage="Are you sure you want to cancel the quote? This will cancel the quote and send a notification to the shipper. You will still be able to submit another quote for this request."
              />
            </p>
          </div>
          <Row className="mt-5">
            <Col lg={12} className="d-flex justify-content-between">
              <Button
                variant="outline-primary"
                label={intl.formatMessage({ id: "general.cancel", defaultMessage: "Cancel" })}
                size="lg"
                onClick={close}
                data-testid={testIds.SHIPMENT_DASHBOARD_QUOTATION_CANCEL_MODAL_CANCEL_BUTTON}
              />
              <Button
                variant="danger"
                type="submit"
                size="lg"
                label={intl.formatMessage({ id: "quote.cancelQuote", defaultMessage: "Cancel quote" })}
                data-testid={testIds.SHIPMENT_DASHBOARD_QUOTATION_CANCEL_MODAL_CANCEL_QUOTE_BUTTON}
              />
            </Col>
          </Row>
        </form>
      </FormProvider>
    </Dialog>
  );
}

export default CancelDialog;
